import React from "react";
import {useOverrides} from "@quarkly/components";
import {Text, Link, Box, Icon, LinkBox, Section} from "@quarkly/widgets";
import {FaDiscord, FaMailBulk} from "react-icons/fa";

const defaultProps = {
    "padding": "60px 0 40px 0",
    "quarkly-title": "Footer-12",
    "background": "transparent",
    "border-top": "1px solid rgba(255, 255, 255, 0.08)"
};

const handleKeyDown = (event, callback) => {
    if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        callback();
    }
};

const overrides = {
    "box": {
        "kind": "Box",
        "props": {
            "display": "grid",
            "lg-width": "100%",
            "flex-direction": "row",
            "lg-flex-direction": "row",
            "justify-content": "space-between",
            "width": "100%",
            "padding": "0 0px 0 0px",
            "lg-padding": "0 0px 30px 0px",
            "margin": "0px 0px 30px 0px",
            "md-flex-wrap": "wrap",
            "md-padding": "0 0px 0 0px",
            "md-margin": "0px 0px 30px 0px",
            "grid-template-columns": "repeat(3, 1fr)",
            "lg-align-items": "start",
            "grid-gap": "36px 34px",
            "md-grid-template-columns": "repeat(2, 1fr)",
            "sm-grid-template-columns": "1fr"
        }
    },
    "box1": {
        "kind": "Box",
        "props": {
            "align-items": "flex-start",
            "lg-align-items": "flex-start",
            "justify-content": "flex-start",
            "display": "grid",
            "lg-flex-direction": "column",
            "flex-direction": "column",
            "flex-wrap": "wrap",
            "align-content": "start",
            "grid-gap": "12px 0",
            "lg-justify-content": "start"
        }
    },
    "text": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 20px 0px",
            "font": "normal 600 22px/1.4 --fontFamily-sans",
            "color": "#ffffff",
            "md-margin": "0px 0px 10px 0px",
            "children": "Legal Documents"
        }
    },
    "link": {
        "kind": "Link",
        "props": {
            "border-color": "--color-primary",
            "display": "flex",
            "font": "normal 400 15px/24px --fontFamily-googleRoboto",
            "margin": "0px 0 0px 0",
            "lg-border-width": "0px 0px 0px 2px",
            "href": "https://docs.cdzv.com/code-zero-visual-trading_en/support/term-of-use",
            "text-decoration-line": "none",
            "color": "rgba(255, 255, 255, 0.75)",
            "hover-color": "#c084fc",
            "target": "_blank",
            "tabIndex": 0,
            "aria-label": "Terms of use",
            "sm-min-height": "44px",
            "sm-padding": "12px 0",
            "transition": "all 0.25s ease",
            "children": "Terms of use"
        }
    },
    "link1": {
        "kind": "Link",
        "props": {
            "margin": "0px 0 0px 0",
            "display": "flex",
            "href": "https://docs.cdzv.com/code-zero-visual-trading_en/support/privacy-policy",
            "font": "normal 400 15px/24px --fontFamily-googleRoboto",
            "text-decoration-line": "none",
            "color": "rgba(255, 255, 255, 0.75)",
            "hover-color": "#c084fc",
            "target": "_blank",
            "tabIndex": 0,
            "aria-label": "Privacy Policy",
            "sm-min-height": "44px",
            "sm-padding": "12px 0",
            "transition": "all 0.25s ease",
            "children": "Privacy Policy"
        }
    },
    "link2": {
        "kind": "Link",
        "props": {
            "margin": "0px 0 0px 0",
            "hover-color": "#c084fc",
            "href": "https://docs.cdzv.com/code-zero-visual-trading_en/support/disclaimer",
            "text-decoration-line": "none",
            "color": "rgba(255, 255, 255, 0.75)",
            "font": "normal 400 15px/24px --fontFamily-googleRoboto",
            "display": "flex",
            "target": "_blank",
            "tabIndex": 0,
            "aria-label": "Disclaimer",
            "sm-min-height": "44px",
            "sm-padding": "12px 0",
            "transition": "all 0.25s ease",
            "children": "Disclaimer"
        }
    },
    "box2": {
        "kind": "Box",
        "props": {
            "min-width": "100px",
            "min-height": "100px",
            "sm-width": "100%",
            "sm-padding": "0px 0px 0px 0",
            "display": "flex",
            "flex-direction": "column",
            "align-items": "flex-start"
        }
    },
    "text1": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 20px 0px",
            "font": "normal 600 22px/1.4 --fontFamily-sans",
            "color": "#ffffff",
            "children": "Contact"
        }
    },
    "text2": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 20px 0px",
            "font": "--base",
            "color": "rgba(255, 255, 255, 0.65)",
            "children": "passeig Garcia Faria, 75, Barcelona, 08019"
        }
    },
    "link4": {
        "kind": "Text",
        "props": {
            "href": "#",
            "color": "rgba(255, 255, 255, 0.75)",
            "text-decoration-line": "initial",
            "font": "--base",
            "display": "inline-block",
            "margin": "0px 0px 15px 0px",
            "hover-color": "#c084fc",
            "children": <>
                <a
                    href={"mailto:support@cdzv.com"}
                    target={"_blank"}
                    rel={"noopener noreferrer"}
                    tabIndex={0}
                    aria-label="Email support"
                    onKeyDown={(e) => handleKeyDown(e, () => window.open("mailto:support@cdzv.com", "_blank"))}
                    style={{
                        color: "rgba(255, 255, 255, 0.75)",
                        transition: "all 0.25s ease",
                        minHeight: "44px",
                        display: "inline-block",
                        padding: "4px 0",
                        outline: "none",
                        textDecoration: "none"
                    }}
                    onFocus={(e) => e.target.style.outline = "2px solid #a855f7"}
                    onBlur={(e) => e.target.style.outline = "none"}
                    onMouseEnter={(e) => e.target.style.color = "#c084fc"}
                    onMouseLeave={(e) => e.target.style.color = "rgba(255, 255, 255, 0.75)"}
                >EMail</a><br/>
                <a
                    href={"https://t.me/cdzv_com_support_bot"}
                    target={"_blank"}
                    rel={"noopener noreferrer"}
                    tabIndex={0}
                    aria-label="Telegram support"
                    onKeyDown={(e) => handleKeyDown(e, () => window.open("https://t.me/cdzv_com_support_bot", "_blank"))}
                    style={{
                        color: "rgba(255, 255, 255, 0.75)",
                        transition: "all 0.25s ease",
                        minHeight: "44px",
                        display: "inline-block",
                        padding: "4px 0",
                        outline: "none",
                        textDecoration: "none"
                    }}
                    onFocus={(e) => e.target.style.outline = "2px solid #a855f7"}
                    onBlur={(e) => e.target.style.outline = "none"}
                    onMouseEnter={(e) => e.target.style.color = "#c084fc"}
                    onMouseLeave={(e) => e.target.style.color = "rgba(255, 255, 255, 0.75)"}
                >Telegram</a>
            </>
        }
    },
    "box3": {
        "kind": "Box",
        "props": {
            "min-width": "100px",
            "min-height": "100px",
            "sm-width": "100%",
            "sm-padding": "0px 0px 0px 0",
            "md-width": "100%"
        }
    },
    "text3": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 20px 0px",
            "font": "normal 600 22px/1.4 --fontFamily-sans",
            "color": "#ffffff",
            "children": "Solution"
        }
    },
    "text4": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 20px 0px",
            "font": "--base",
            "color": "rgba(255, 255, 255, 0.65)",
            "children": "The smartest way to test, optimize and automate your trading strategies."
        }
    },
    "box4": {
        "kind": "Box",
        "props": {
            "min-width": "10px",
            "min-height": "10px",
            "display": "flex",
            "grid-template-columns": "repeat(5, 1fr)",
            "grid-gap": "16px 24px",
            "md-align-self": "flex-start",
            "sm-align-self": "center",
            "justify-items": "start",
            "align-items": "center",
            "justify-content": "flex-start"
        }
    },
    "linkBox": {
        "kind": "LinkBox",
        "props": {
            "href": "https://discord.com/invite/cu5tPqz4ft",
            "target": "_blank",
            "pointer-events": "auto",
            "tabIndex": 0,
            "aria-label": "Discord community",
            "sm-min-height": "44px",
            "sm-min-width": "44px"
        }
    },
    "icon": {
        "kind": "Icon",
        "props": {
            "category": "fa",
            "icon": FaDiscord,
            "size": "24px",
            "color": "rgba(255, 255, 255, 0.75)",
            "hover-color": "#c084fc",
            "transition": "all 0.25s ease"
        }
    },
    "linkBox2": {
        "kind": "LinkBox",
        "props": {
            "href": "mailto:support@cdzv.com?I need help",
            "target": "_blank",
            "tabIndex": 0,
            "aria-label": "Email support",
            "sm-min-height": "44px",
            "sm-min-width": "44px"
        }
    },
    "icon2": {
        "kind": "Icon",
        "props": {
            "category": "fa",
            "icon": FaMailBulk,
            "size": "24px",
            "color": "rgba(255, 255, 255, 0.75)",
            "hover-color": "#c084fc",
            "transition": "all 0.25s ease"
        }
    },
    "box5": {
        "kind": "Box",
        "props": {
            "display": "block",
            "padding": "0 0px 0px 0px",
            "border-color": "--color-lightD2",
            "md-padding": "0 0px 0px 0px",
            "md-flex-direction": "column"
        }
    },
    "text5": {
        "kind": "Text",
        "props": {
            "margin": "0px 0px 0px 0px",
            "font": "--base",
            "color": "rgba(255, 255, 255, 0.55)",
            "md-margin": "0px 0px 25px 0px",
            "sm-text-align": "center",
            "text-align": "center",
            "letter-spacing": "1px",
            "children": <>
                <hr style={{
                    borderColor: "rgba(255, 255, 255, 0.1)",
                    borderStyle: "solid",
                    borderWidth: "1px 0 0 0",
                    margin: "30px 0"
                }}/>
                <span style={{
                    fontSize: "12px",
                    display: "block",
                    lineHeight: "1.6",
                    marginBottom: "15px",
                    color: "rgba(255, 255, 255, 0.45)"
                }}>
                CDZV.COM provides software only. Any references to trading, exchange, transfer, or wallet services, etc. are references to services provided by third-party service providers.
                </span>
                © 2023-2026 | CDZV.COM | All rights reserved.
            </>
        }
    }
};

const CdzvFooter = props => {
    const {
        override,
        children,
        rest
    } = useOverrides(props, overrides, defaultProps);
    return <Section {...rest}>
        <Box {...override("box")}>
            <Box {...override("box1")}>
                <Text {...override("text")} />
                <Link
                    {...override("link")}
                    onKeyDown={(e) => handleKeyDown(e, () => window.open(override("link").props.href, "_blank"))}
                    onFocus={(e) => e.target.style.outline = "2px solid #a855f7"}
                    onBlur={(e) => e.target.style.outline = "none"}
                />
                <Link
                    {...override("link1")}
                    onKeyDown={(e) => handleKeyDown(e, () => window.open(override("link1").props.href, "_blank"))}
                    onFocus={(e) => e.target.style.outline = "2px solid #a855f7"}
                    onBlur={(e) => e.target.style.outline = "none"}
                />
                <Link
                    {...override("link2")}
                    onKeyDown={(e) => handleKeyDown(e, () => window.open(override("link2").props.href, "_blank"))}
                    onFocus={(e) => e.target.style.outline = "2px solid #a855f7"}
                    onBlur={(e) => e.target.style.outline = "none"}
                />
            </Box>
            <Box {...override("box2")}>
                <Text {...override("text1")} />
                <Text {...override("text2")} />
                <Text {...override("link4")} />
            </Box>
            <Box {...override("box3")}>
                <Text {...override("text3")} />
                <Text {...override("text4")} />
                <Box {...override("box4")}>
                    <LinkBox
                        {...override("linkBox2")}
                        onKeyDown={(e) => handleKeyDown(e, () => window.open(override("linkBox2").props.href, "_blank"))}
                        style={{outline: "none"}}
                        onFocus={(e) => e.target.style.outline = "2px solid #a855f7"}
                        onBlur={(e) => e.target.style.outline = "none"}
                    >
                        <Icon {...override("icon2")} />
                    </LinkBox>
                </Box>
            </Box>
        </Box>
        <Box {...override("box5")}>
            <Text {...override("text5")} />
        </Box>
        {children}
    </Section>;
};

Object.assign(CdzvFooter, {
    ...Section,
    defaultProps,
    overrides
});
export default CdzvFooter;
